import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageFooterComponent } from './page-footer/page-footer.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { RouterModule } from '@angular/router';
import {
  DsButtonModule,
  DsCalendarModule,
  DsCheckboxModule,
  DsConfirmDialogModule,
  DsInputModule,
  DsKrsModule,
  DsLoaderModule,
  DsModalModule,
  DsNotificationModule,
  DsPanelModule,
  DsRadioModule,
  DsStatusModule,
  DsTableModule,
} from 'design-system';
import { DestroyComponent } from './destroy/destroy.component';
import { MenuDropdownComponent } from './menu-dropdown/menu-dropdown.component';
import { DanePodmiotuComponent } from './dane-podmiotu/dane-podmiotu.component';
import { TranslocoModule } from '@ngneat/transloco';
import { InstrukcjaComponent } from './instrukcja/instrukcja.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubskrypcjeTabelaComponent } from './subskrypcje-tabela/subskrypcje-tabela.component';
import { MonitorowaniePodmiotuFormComponent } from './monitorowanie-podmiotu-form/monitorowanie-podmiotu-form.component';
import { HttpErrorModalComponent } from './http-error-modal/http-error-modal.component';
import { SubskrypcjeFiltryComponent } from './subskrypcje-filtry/subskrypcje-filtry.component';
import { NotificationBlockComponent } from './notification-block/notification-block.component';
import { BellNotificationComponent } from './bell-notification/bell-notification.component';

const COMPONENTS = [
  PageFooterComponent,
  PageHeaderComponent,
  DestroyComponent,
  MenuDropdownComponent,
  DanePodmiotuComponent,
  InstrukcjaComponent,
  SubskrypcjeTabelaComponent,
  MonitorowaniePodmiotuFormComponent,
  HttpErrorModalComponent,
  NotificationBlockComponent,
  BellNotificationComponent,
];

@NgModule({
  declarations: [...COMPONENTS, SubskrypcjeFiltryComponent],
    exports: [...COMPONENTS, SubskrypcjeFiltryComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoModule,
    DsButtonModule,
    DsKrsModule,
    DsInputModule,
    DsLoaderModule,
    DsPanelModule,
    DsTableModule,
    DsNotificationModule,
    DsCalendarModule,
    DsCheckboxModule,
    DsModalModule,
    DsConfirmDialogModule,
    DsStatusModule,
    DsRadioModule
  ],
})
export class ComponentsModule {}
